// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__rjpOj","signatureBlock":"Footer_signatureBlock___Bcsw","signature":"Footer_signature__1o1nq"};